export default __webpack_public_path__ + "static/media/JobThree2.4b177842.JPG";